import {
    ASYNC_FETCH_CHARGES,
    ASYNC_FETCH_SUCCESS_CHARGES,
    ASYNC_FETCH_FAILURE_CHARGES,
  } from '../constants';
  import { updateObject } from '../../../utilities/reducer';
  import common from '../../../utilities/common';
  
  const initialState = {
      isFetching: true,
      statusCode: "",
      statusMessage: "",
      errorMessage: '',
      errorDesc: '',
      actionName: '',
      actionValue: '',
      errorObj: {},
      pageData: "",
  };
  
  export const asyncFetch = (state, action) => {
      console.log("getSectionsBegin called")
      return updateObject(state, {
          isFetching: true
      });
  };
  
  export const asyncFetchSuccess = (state, action) => {
    
      return updateObject(state, {
          isFetching: false,
          statusCode: action.msResp.responseInfo && action.msResp.responseInfo.responseCode,
          statusMessage: action.msResp.responseInfo && action.msResp.responseInfo.responseMessage,
          errorMessage: common.isError(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
          errorDesc: common.isErrorDesc(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
          actionName: common.isActionName(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
          actionValue: common.isActionValue(action.msResp.responseInfo && action.msResp.responseInfo.responseCode, action.msResp.responseInfo && action.msResp.responseInfo.responseMessage, action.msResp.body),
          errorObj: action.msResp.responseInfo && action.msResp.responseInfo.responseCode !== "00" && action.msResp.responseInfo ? action.msResp.responseInfo && action.msResp.responseInfo.sectionErrors : null,
          pageData: action.msResp
      });
      
  };
  
  export const asyncFetchFailed = (state, action) => {
     
      //Dont Delete this code untill implementing code to handel 500 status code error
      let msResp = action && action.err && action.err.response && action.err.response.data;
      let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
      let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
      let body = msResp && msResp.body;
      return updateObject(state, {
          isFetching: false,
          pageData: {},
          statusCode: responseCode ? responseCode : '',
          errorMessage: common.isError(responseCode, responseMessage, body),
          errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
          actionName: common.isActionName(responseCode, responseMessage, body),
          actionValue: common.isActionValue(responseCode, responseMessage, body),
          errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
      });
  };
  
  const ChargesModalReducer = (state = initialState, action) => {
  
      const { type } = action;
      switch (type) {
          case ASYNC_FETCH_CHARGES:
              return asyncFetch(state, action);
          case ASYNC_FETCH_SUCCESS_CHARGES:
              return asyncFetchSuccess(state, action);
          case ASYNC_FETCH_FAILURE_CHARGES:
              return asyncFetchFailed(state, action);
          default:
              return state;
      }
  };
  
  export default ChargesModalReducer;
  